import dayjs, { Dayjs } from "dayjs";

export const formatDate = (inputDate: string | Date | null): string => {
  if (!inputDate) return "-";
  return dayjs(inputDate).format("DD/MM/YY");
};

export const formatApiStartDate = (inputDate: string | Date | Dayjs | null): string | null => {
  if (!inputDate) return null;
  return dayjs(inputDate).startOf('day').toISOString();
};

export const formatApiEndDate = (inputDate: string | Date | Dayjs | null): string | null => {
  if (!inputDate) return null;
  return dayjs(inputDate).endOf('day').toISOString();
};